module.exports = __webpack_public_path__ + "static/valmir-0635571d781d047ce24e9b7286822086.png";